module.exports = __webpack_public_path__ + "img/ai_report_bg.215b1814.png";